import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import IsAuthenticatedQuery from '../IsAuthenticated.gql';
var AuthContext = /*#__PURE__*/React.createContext({});

var AuthHookProvider = function AuthHookProvider(_ref) {
  var _data$user, _data$user2, _data$user3, _data$user4;

  var children = _ref.children;

  var _useQuery = useQuery(IsAuthenticatedQuery, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      error = _useQuery.error;

  if (process.env.BUILD_ENV !== 'production') {
    console.log('If your app is infinitely loading or crashing, you might need to log in first!');
  }

  var authValue = {
    auth: {
      error: error,
      isAccountClosed: !!(data === null || data === void 0 ? void 0 : (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.closedAt),
      isUserLoggedIn: !!(data === null || data === void 0 ? void 0 : (_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.uuid),
      isUserRegComplete: !!(data === null || data === void 0 ? void 0 : (_data$user3 = data.user) === null || _data$user3 === void 0 ? void 0 : _data$user3.registrationComplete),
      isLoading: loading,
      uuid: data === null || data === void 0 ? void 0 : (_data$user4 = data.user) === null || _data$user4 === void 0 ? void 0 : _data$user4.uuid
    }
  };
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: authValue
  }, children);
};

var useAuth = function useAuth() {
  return useContext(AuthContext);
};

export { AuthHookProvider, useAuth };